import { faArrowLeft, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import authService from "../../../../services/login/auth.service"
import { WizardContext } from "../../../generico/CustomStepWizard";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";

export const PagoSepelioPaso3 = (props) => {

    const sepelioContext = useContext(WizardContext);

    const { state, resetState, descargarComprobante } = sepelioContext;

    const returnToFirstStep = () => {
        resetState();
        props.firstStep();
    }

    mensajeExito("El Pago se Realizó Correctamente");

    return (
        <div>
            <div className="row justify-content-md-center">
                <div className="col-lg-7 col-md-10">
                    <p className="nro-operacion">
                        Número de Operación: {state?.codOperacion}
                    </p>
                </div>
            </div>
            <div className="row justify-content-md-center">
                <div className="col-lg-7 col-md-10">
                    <h6 style={{ margin: 0 }}>
                        Socio: {authService.getSocio().numeroSocio.trim()} -{" "}
                        {authService.getSocio().nombreCompleto}
                    </h6>
                    <p style={{ marginBottom: 0 }}>
                        Cuenta: {state?.ctaFullData.idAhorro}-
                        {state?.ctaFullData.descripcion}
                    </p>
                    <p>Moneda: {state?.moneda}.</p>
                    <p>Fecha de Operación: {(new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })}</p>
                    <h6>
                        Total a Pagar: {formatoSeparadorMilesValue(state.infoPagare.montoAPagar)} {state?.moneda}.
                    </h6>
                </div>
            </div>

            <hr />

            <div className="row">
                <div className="col-lg-8 col-md-6"></div>
                <div className="col-lg-2 col-md-3">
                <button
                    onClick={returnToFirstStep}
                    type="button"
                    className="btn btn-cu-quintary btn-consulta"
                >
                  <FontAwesomeIcon icon={faArrowLeft}/>  Ir al Inicio
                </button>
                </div>
                <div className="col-lg-2 col-md-3">
                <button className="btn btn-cu-primary" onClick={descargarComprobante}><FontAwesomeIcon icon={faFilePdf} /> Descargar Comprobante</button>
                </div>
               
                
            </div>
        </div >
    )
}